import { render, staticRenderFns } from "./SurveyStatus.vue?vue&type=template&id=87e84a30"
import script from "./SurveyStatus.vue?vue&type=script&lang=js"
export * from "./SurveyStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports